import { Toast } from '@stores/toaster';

export const failedGetTeams = (): Toast => ({
  heading: 'Failed to load teams',
  icon: 'error',
  text: 'Please try again later, or contact support.'
});
